export const ORGANIZERS_DATA = [
	{
		name: "Sowmya M.N",
		event_role: "Publisher",
		professional_role: "Main Co-ordinator",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/sowmya.jpg")
			.default,
		social_media: {
			linkedin: "https://www.linkedin.com/in/sowmya-mn-a69261246/",
		},
	},
	{
		name: "Rakshith Kumar D",
		event_role: "Publisher",
		professional_role: "Main Co-ordinator",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/rakshith.jpg")
			.default,
		social_media: {
			linkedin: "linkedin.com/in/rakshith-kumar-d-92162322a/",
		},
	},
	{
		name: "Ganesh K C",
		event_role: "Codex Co-ordinator",
		professional_role: "Main Co-ordinator",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/ganesh.jpg")
			.default,
		social_media: {
			linkedin: "https://www.linkedin.com/in/ganesh-kc-80b761245",
		},
	},
	{
		name: "Jesica G V",
		event_role: "Technical Co-ordinator",
		professional_role: "Technical Co-ordinator",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/jesica.jpg")
			.default,
		social_media: {
			linkedin: "",
		},
	},
	{
		name: "Keerthan Gowda H K ",
		event_role: "Codex Co-ordinator",
		professional_role: "Non-Technical Co-ordinator",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/keerthan.jpg")
			.default,
		social_media: {
			linkedin: "",
		},
	},
	{
		name: "Sindhushree V ",
		event_role: "Decoration Co-ordinator",
		professional_role: "Decoration Co-ordinator ",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/sindhu.jpg")
			.default,
		social_media: {
			linkedin: "",
		},
	},
	{
		name: "Lavanya N Murthy",
		event_role: "Decoration Co-ordinator",
		professional_role: "Decoration Co-ordinator ",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/lavanya.jpg")
			.default,
		social_media: {
			linkedin: "",
		},
	},
	{
		name: "Chaithanya. M",
		event_role: "Decoration Co-ordinator",
		professional_role: "Decoration Co-ordinator ",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/chaithanya.png")
			.default,
		social_media: {
			linkedin: "",
		},
	},
	{
		name: "Shibin C Reji",
		event_role: "Codex Co-ordinator",
		professional_role: "CodeX Co-ordinator",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/shibin.jpg")
			.default,
		social_media: {
			linkedin: "https://www.linkedin.com/in/shibincreji",
		},
	},
	{
		name: "Sanskar Drolia",
		event_role: "Codex Co-ordinator",
		professional_role: "CodeX Co-ordinator",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/sanskar.png")
			.default,
		social_media: {
			linkedin: "https://www.linkedin.com/in/sanskardrolia",
		},
	},
	{
		name: "Shankarling",
		event_role: "Codex Co-ordinator",
		professional_role: "CodeX Co-ordinator",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/shankarling.jpg")
			.default,
		social_media: {
			linkedin: "https://www.linkedin.com/in/shankarling-kalashetty-b59149204/",
		},
	},
	{
		name: "Santosh K",
		event_role: "Codex Co-ordinator",
		professional_role: "CodeX Co-ordinator",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/santhosh.jpg")
			.default,
		social_media: {
			linkedin: "https://www.linkedin.com/in/santoshk132",
		},
	},
	{
		name: "Sneha Aparna",
		event_role: "Pixel Wizard Co-ordinator",
		professional_role: "Pixel Wizard Co-ordinator",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/sneha.jpg")
			.default,
		social_media: {
			linkedin: "https://www.linkedin.com/in/sneha-aparna-4b390a238/",
		},
	},
	{
		name: "Samyuktha R",
		event_role: "Pixel Wizard Co-ordinator",
		professional_role: "Pixel Wizard Co-ordinator",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/samyukthar.jpg")
			.default,
		social_media: {
			linkedin: "https://www.linkedin.com/in/samyuthar/",
		},
	},
	{
		name: "Samyuktha S",
		event_role: "Pixel Wizard Co-ordinator",
		professional_role: "Pixel Wizard Co-ordinator",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/samyukthas.jpg")
			.default,
		social_media: {
			linkedin: "https://www.linkedin.com/in/samyuktha-s-701235239/",
		},
	},
	{
		name: "Sneha N V",
		event_role: "Pixel Wizard Co-ordinator",
		professional_role: "Pixel Wizard Co-ordinator",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/snehanv.jpg")
			.default,
		social_media: {
			linkedin: "https://www.linkedin.com/in/sneha-n-v-naik-172ab6246/",
		},
	},
	{
		name: "Keerthana R",
		event_role: "Pixel Wizard Co-ordinator",
		professional_role: "Paper Presentation Co-ordinator",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/keerthanar.jpg")
			.default,
		social_media: {
			linkedin: "https://www.linkedin.com/in/keerthana-r-3003871bb",
		},
	},
	{
		name: "Madhushalini M",
		event_role: "Pixel Wizard Co-ordinator",
		professional_role: "Paper Presentation Co-ordinator",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/madhushalini.jpg")
			.default,
		social_media: {
			linkedin: "",
		},
	},
	{
		name: "Meghana S",
		event_role: "Pixel Wizard Co-ordinator",
		professional_role: "Paper Presentation Co-ordinator",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/meghana.jpg")
			.default,
		social_media: {
			linkedin: "",
		},
	},
	{
		name: "Rohan R",
		event_role: "Technical Quiz Co-ordinator",
		professional_role: "Technical Quiz Co-ordinator",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/rohan.jpg")
			.default,
		social_media: {
			linkedin: "",
		},
	},
	{
		name: "PS Vijayrangan",
		event_role: "Technical Quiz Co-ordinator",
		professional_role: "Technical Quiz Co-ordinator",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/vijay.jpg")
			.default,
		social_media: {
			linkedin: "",
		},
	},
	{
		name: "Simple K S ",
		event_role: "Pixel Wizard Co-ordinator",
		professional_role: "Treasure Hunt Co-ordinator",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/simple.jpg")
			.default,
		social_media: {
			linkedin: "",
		},
	},
	{
		name: "Srivalli N",
		event_role: "Pixel Wizard Co-ordinator",
		professional_role: "Treasure Hunt Co-ordinator",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/srivalli.jpg")
			.default,
		social_media: {
			linkedin: "",
		},
	},
	{
		name: "Hemavathi R",
		event_role: "Pixel Wizard Co-ordinator",
		professional_role: "Treasure Hunt Co-ordinator",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/hema.jpg")
			.default,
		social_media: {
			linkedin: "",
		},
	},
	{
		name: "Keerthana HS ",
		event_role: "Pixel Wizard Co-ordinator",
		professional_role: "Cooking without Fire Co-ordinator",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/keerthana.jpg")
			.default,
		social_media: {
			linkedin: "",
		},
	},
	{
		name: "Gunashree N A",
		event_role: "Pixel Wizard Co-ordinator",
		professional_role: "Cooking without Fire Co-ordinator",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/guna.jpg")
			.default,
		social_media: {
			linkedin: "",
		},
	},
	{
		name: "Deekshitha U M",
		event_role: "Pixel Wizard Co-ordinator",
		professional_role: "Cooking without Fire Co-ordinator",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/deekshitha.jpg")
			.default,
		social_media: {
			linkedin: "",
		},
	},
	{
		name: "Shyam Sundar G ",
		event_role: "Pixel Wizard Co-ordinator",
		professional_role: "Bakasura Co-ordinator",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/shyam.jpg")
			.default,
		social_media: {
			linkedin: "",
		},
	},
	{
		name: "Jeevan Y",
		event_role: "Golden Minutes Co-ordinator",
		professional_role: "Golden Minutes Co-ordinator",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/jeevan.jpg")
			.default,
		social_media: {
			linkedin: "",
		},
	},
	{
		name: "Alisha S",
		event_role: "Golden Minutes Co-ordinator",
		professional_role: "Golden Minutes Co-ordinator",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/alisha.jpg")
			.default,
		social_media: {
			linkedin: "",
		},
	},
	{
		name: "B V MANASI",
		event_role: "Golden Minutes Co-ordinator",
		professional_role: "Golden Minutes Co-ordinator",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/manasi.jpg")
			.default,
		social_media: {
			linkedin: "",
		},
	},
	{
		name: "Amogh",
		event_role: "BGMI Co-ordinator",
		professional_role: "BGMI Co-ordinator",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/amogh.jpg")
			.default,
		social_media: {
			linkedin: "",
		},
	},
	{
		name: "Sri Hari Reddy",
		event_role: "BGMI Co-ordinator",
		professional_role: "BGMI Co-ordinator",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/srihari.jpg")
			.default,
		social_media: {
			linkedin: "",
		},
	},
	{
		name: "Adithya J",
		event_role: "BGMI Co-ordinator",
		professional_role: "BGMI Co-ordinator",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/adithya.jpg")
			.default,
		social_media: {
			linkedin: "",
		},
	},
	{
		name: "Sahana Raja",
		event_role: "BGMI Co-ordinator",
		professional_role: "Shout in silence Co-ordinator",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/sahana.jpg")
			.default,
		social_media: {
			linkedin: "",
		},
	},
	{
		name: "Shobha Gowda",
		event_role: "BGMI Co-ordinator",
		professional_role: "Shout in silence Co-ordinator",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/shoba.jpeg")
			.default,
		social_media: {
			linkedin: "",
		},
	},
	{
		name: "Nagaprasad K",
		event_role: "Volleyball coordinator",
		professional_role: "Volleyball coordinator",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/naga.jpg")
			.default,
		social_media: {
			linkedin: "",
		},
	},
	{
		name: "Geethashree",
		event_role: "Media Co-ordinator",
		professional_role: "Media Co-ordinator",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/geetha.jpg")
			.default,
		social_media: {
			linkedin: "",
		},
	},
	{
		name: "Nandish K",
		event_role: "Codex Co-ordinator",
		professional_role: "Discipline Co-ordinator",
		institution: "CSE, RRCE",
		avatar_url: require("../assets/images/organizers/nandish.jpeg")
			.default,
		social_media: {
			linkedin: "",
		},
	},
];
